import { setMakeDate } from "../../../helpers/utils";

const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL;

export const SET_AUTORISATION = async (data) => {
  const response = await fetch(`${baseApiUrl}/auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_ME = async (token) => {
  const response = await fetch(`${baseApiUrl}/auth/me`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_CURRENCY = async (token) => {
  const response = await fetch(`${baseApiUrl}/currency`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_ALL_CUSTOMERS = async (token) => {
  const response = await fetch(`${baseApiUrl}/customer`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_CUSTOMER = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/account?platform_id=${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_OPERATIONS = async (
  token,
  account_id,
  platform_id,
  from = "",
  to = setMakeDate({ id: 1 }).to
) => {
  const response = await fetch(
    `${baseApiUrl}/operation?platform_id=${platform_id}&account_ids=${JSON.stringify(
      [account_id]
    )}&from=${from}&to=${to}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const SHOW_OPERATION = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/operation/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const DELETE_OPERATION = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/operation/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const EDIT_OPERATION = async (token, id, data) => {
  const response = await fetch(`${baseApiUrl}/operation/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const CREATE_OPERATION = async (token, data) => {
  const response = await fetch(`${baseApiUrl}/operation/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_ALL_TYPES = async (token, account_id) => {
  const response = await fetch(`${baseApiUrl}/type?account_id=${account_id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_TYPE = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/type/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const DELETE_TYPE = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/type/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

// export const EDIT_TYPE = async (id) => {
//   const response = await fetch(`${baseApiUrl}/type/${id}`, {
//     method: 'PUT',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//       'Cache-Control': 'no-cache',
//     },
//   })
//   const result = await response.json()
//   return result
// }

// export const CREATE_TYPE = async () => {
//   const response = await fetch(`${baseApiUrl}/type/create`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//       'Cache-Control': 'no-cache',
//     },
//   })
//   const result = await response.json()
//   return result
// }

export const GET_CATEGORIES = async (token, page = 1, account_id, type_id) => {
  const response = await fetch(
    `${baseApiUrl}/category?page=${page}&account_id=${account_id}&type_id=${type_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const SHOW_CATEGORY = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/category/${id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const DELETE_CATEGORY = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/category/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const EDIT_CATEGORY = async (token, data, id) => {
  const response = await fetch(`${baseApiUrl}/category/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const CREATE_CATEGORY = async (token, data) => {
  const response = await fetch(`${baseApiUrl}/category/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
    body: data,
  });
  const result = await response.json();
  return result;
};

export const GET_ACCOUNT = async (token, platform_id) => {
  const response = await fetch(
    `${baseApiUrl}/account?platform_id=${platform_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const CREATE_ACCOUNT = async (token) => {
  const response = await fetch(`${baseApiUrl}/account/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const SHOW_ACCOUNT = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/account/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const DELETE_ACCOUNT = async (token, id) => {
  const response = await fetch(`${baseApiUrl}/account/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const GET_ANALYTICS = async (
  token,
  { platform_id, account_id, from = "", to = "", currency_id, type_id }
) => {
  const response = await fetch(
    `${baseApiUrl}/analytic?platform_id=${platform_id}&account_id=${account_id}&from=${from}&to=${to}&currency_id=${currency_id}&type_id=${type_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_ANALYTICS_OPERATIONS = async (
  token,
  {
    account_id,
    platform_id,
    type_id = null,
    from = "",
    to = "",
    page = 1,
    category_id,
  }
) => {
  const response = await fetch(
    `${baseApiUrl}/operation?platform_id=${platform_id}&account_id=${account_id}&type_id=${type_id}&from=${from}&to=${to}&page=${page}&category_id=${category_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_DRAW_OPERATIONS = async (
  token,
  { account_id, platform_id }
) => {
  const response = await fetch(
    `${baseApiUrl}/operation/list-draw?platform_id=${platform_id}&account_id=${account_id}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_INVITES_LINK = async (token, customer_id) => {
  const response = await fetch(
    `${baseApiUrl}/customer/${customer_id}/referer-link`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_BONUS = async (token, { customer_id, from, to }) => {
  const response = await fetch(
    `${baseApiUrl}/bonus?customer_id=${customer_id}&from=${from}&to=${to}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const GET_TARIFF = async (token) => {
  const response = await fetch(`${baseApiUrl}/tariff`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Authorization: "Bearer " + token,
    },
  });
  const result = await response.json();
  return result;
};

export const SET_PURCHASE_TARIFF = async (token, customer_id, data) => {
  const response = await fetch(
    `${baseApiUrl}/customer/${customer_id}/purchase-tariff`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
      body: data,
    }
  );
  const result = await response.json();
  return result;
};

export const SET_SETTINGS_PUSH = async (token, customer_id, data) => {
  const response = await fetch(
    `${baseApiUrl}/customer/${customer_id}/settings`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        Authorization: "Bearer " + token,
      },
      body: data,
    }
  );
  const result = await response.json();
  return result;
};
